export default function StartQuiz({ dispatch, numQuestion }) {
  return (
    <>
      <h2> Welcome to The React Quiz!</h2>
      <h3>{numQuestion} questions to test your React mastery</h3>
      <button
        className="btn"
        onClick={() => {
          dispatch({ type: "startQuiz" });
        }}
      >
        Let's Start
      </button>
    </>
  );
}
